"use client";

import { useEffect, useState } from "react";
import Icon from "@/components/ui/AppIcon";
import AppImage from "@/components/ui/AppImage";

const HeroSection = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const floatingImages = [
  {
    id: "float_1",
    src: "https://images.unsplash.com/photo-1643153571071-9cf86636ed86",
    alt: "Construction site with workers laying foundation",
    className: "absolute top-20 left-10 w-32 h-32 rounded-2xl shadow-xl animate-float-slow opacity-60"
  },
  {
    id: "float_2",
    src: "https://img.rocket.new/generatedImages/rocket_gen_img_1ea956199-1768116103175.png",
    alt: "Modern residential building under construction",
    className: "absolute top-40 right-20 w-40 h-40 rounded-2xl shadow-xl animate-float-delayed opacity-50"
  },
  {
    id: "float_3",
    src: "https://img.rocket.new/generatedImages/rocket_gen_img_103d8822e-1770029782067.png",
    alt: "Completed affordable housing complex",
    className: "absolute bottom-32 left-20 w-36 h-36 rounded-2xl shadow-xl animate-float-slow opacity-40"
  }];


  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-gradient-to-b from-white to-muted">
      {/* Grid Background */}
      <div className="absolute inset-0 grid-lines opacity-40"></div>
      {/* Floating Images (only on desktop) */}
      {isHydrated &&
      <div className="hidden lg:block absolute inset-0 pointer-events-none">
          {floatingImages?.map((img) =>
        <div key={img?.id} className={img?.className}>
              <AppImage
            src={img?.src}
            alt={img?.alt}
            className="w-full h-full object-cover rounded-2xl" />

            </div>
        )}
        </div>
      }
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 lg:px-8 text-center py-20">
        <div className="max-w-4xl mx-auto space-y-8">
          {/* Trust Badge */}
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-white border border-primary/20 shadow-md">
            <div className="w-2 h-2 bg-primary rounded-full animate-pulse"></div>
            <span className="text-xs font-bold uppercase tracking-widest text-foreground">
              Trusted Since 2002
            </span>
            <div className="w-2 h-2 bg-primary rounded-full animate-pulse"></div>
          </div>

          {/* Main Headline */}
          <div className="flex flex-col items-center justify-center">
            <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-bold text-foreground leading-tight tracking-tight text-center">
              Affordable Homes for <br />
              <span className="text-primary">Kolkata Families</span>
            </h1>
            
            {/* Tagline */}
            <div className="space-y-2 mt-6">
              <p className="font-handwritten text-3xl md:text-5xl text-secondary rotate-[-2deg] inline-block">
                Foundation Se Finishing Tak!
              </p>
              <p className="text-sm md:text-base text-muted-foreground italic">
                Kolkata'r Madhyabitta Parivar'er Biswas
              </p>
            </div>
          </div>

          {/* Description */}
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Building dreams for middle-class families with honest construction, 
            durable quality, and affordable pricing. Serving only Kolkata since 2002.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-6">
            <a
              href="tel:+919088998873"
              className="w-full sm:w-auto px-10 py-4 bg-primary text-primary-foreground rounded-lg font-bold text-lg hover:bg-accent transition-all hover:scale-105 shadow-lg flex items-center justify-center gap-3">

              <Icon name="PhoneIcon" size={24} />
              Call Now
            </a>
            <a
              href="https://wa.me/919088998873?text=Arati%20Enterprise%0AFoundation%20Se%20Finishing%20Tak!%0A"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-10 py-4 bg-secondary text-secondary-foreground rounded-lg font-bold text-lg hover:bg-yellow-500 transition-all hover:scale-105 shadow-lg flex items-center justify-center gap-3">

              <Icon name="ChatBubbleLeftRightIcon" size={24} />
              WhatsApp Us
            </a>
          </div>

          {/* Quick Info */}
          <div className="flex flex-wrap items-center justify-center gap-8 pt-8 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <Icon name="CheckCircleIcon" size={20} className="text-primary" />
              <span>20+ Years Experience</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="CheckCircleIcon" size={20} className="text-primary" />
              <span>500+ Happy Families</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="CheckCircleIcon" size={20} className="text-primary" />
              <span>Kolkata Only</span>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;